<template>
    <el-table-column
        :prop="item.prop"
        :label="item.label"
        :type="item.type"
        :align="item.align || 'center'"
        :min-width="item['min-width'] || item.minWidth || item.width"
        :fixed="item.fixed"
    >
        <template v-for="(val, index) of item.children">
            <t-table-column
                v-if="val.children"
                :key="index"
                :item="val"
            />
            <el-table-column
                v-else
                v-bind="{...val.bind, ...$attrs}"
                :key="val.prop"
                :prop="val.prop"
                :label="val.label"
                :min-width="val['min-width'] || val.minWidth || val.width"
                :sortable="val.sort"
                :render-header="val.renderHeader || val.headerRequired"
                :align="val.align || 'center'"
                :fixed="val.fixed"
                :show-overflow-tooltip="val.noShowTip ? val.noShowTip : true"
            >
                <template #default="scope">
                    <!-- render渲染 -->
                    <template v-if="val.render">
                        <render-col
                            :column="val"
                            :row="scope.row"
                            :render="val.render"
                            :index="scope.$index"
                        />
                    </template>
                    <!-- 自定义插槽 -->
                    <template v-if="val.slotName">
                        <slot
                            :name="val.slotName"
                            :param="scope"
                        ></slot>
                    </template>
                    <!-- 单个单元格编辑 -->
                    <template v-if="val.canEdit">
                        <single-edit-cell
                            v-bind="$attrs"
                            ref="editCell"
                            v-model="scope.row[scope.column.property]"
                            :can-edit="val.canEdit"
                            :config-edit="val.configEdit"
                            :prop="val.prop"
                            :record="scope"
                            @handle-event="(event:any,model:any) => $emit('handleEvent',event,model,scope.$index)"
                        >
                            <slot
                                v-if="val.configEdit && val.configEdit.editSlotName"
                                :name="val.configEdit.editSlotName"
                                :scope="scope"
                            ></slot>
                        </single-edit-cell>
                    </template>
                    <div v-if="!val.render && !val.slotName && !val.canEdit">
                        {{ scope.row[val.prop] }}
                    </div>
                </template>
            </el-table-column>
        </template>
    </el-table-column>
</template>
<script lang="ts">
export default {
    name: 'TTableColumn'
};
</script>
<script setup lang="ts">
import RenderCol from './renderCol.vue';
defineProps({
    item: {
        type: Object,
        default: () => {
            return {};
        },
        required: true
    }
});
</script>
